import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { modules } from 'src/helpers/utility/rich-editor-toolbar-setup';

export default function TextEditor({ value, onChange, className }: any) {
  return <ReactQuill theme="snow" value={value} onChange={onChange} className={className} modules={modules}/>;
}